import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../../constants/size'
import { useNotification } from '../../../../hooks'
import { FormModal, formValidationSchemaNoChanged } from '../../../Form'
import { getFilteredRecipients } from '../EmailRecipientsField.api'

import {
  getInitialValues,
  getRecipientFilterParams,
  isEqualEmailRecipientsFilterModal,
} from './EmailRecipientsFilterModal.utils'
import { FormFields } from './FormFields'

import * as styles from './EmailRecipientsFilterModal.module.css'

function EmailRecipientsFilterModal({
  autoAddEnabled,
  initialValues,
  onChange,
  onClose,
  onSetMassMailing,
}) {
  const { handleAddSuccessNotification } = useNotification()

  const { t } = useTranslation()

  const initValues = getInitialValues(initialValues, t)

  function handleSubmit({ values }) {
    getFilteredRecipients(getRecipientFilterParams(values, { autoAddEnabled }))
      .then(({ data }) => {
        onSetMassMailing?.()

        handleAddSuccessNotification('Notification.CommonTitleAppliedKey')

        onChange(data.items)
      })
      .finally(() => {
        onClose()
      })
  }

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxProps: {
          className: styles.box,
        },
        boxSize: SIZE.MEDIUM,
        headerProps: {
          className: styles.header,
        },
      }}
      formBodyProps={{
        contentClassName: styles.container,
        contentProps: {
          size: SIZE.X_LARGE,
        },
        submitButtonText: 'Modal.ApplyBtnKey',
        withNotifications: true,
      }}
      formTitle='Modal.RecipientsFilterTitleModalText'
      initialValues={initValues}
      validationSchema={formValidationSchemaNoChanged({
        initialValues: initValues,
        isEqual: isEqualEmailRecipientsFilterModal,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default EmailRecipientsFilterModal
